import styles from "./styles.scss";
import { forwardRef } from "react";
import clsx from "clsx";
import { Attachments } from "@/assets/icons";
import { InputValidatedProps } from "@/components/input-validated/types";
import { transformFileFormats, validateFile } from "./utils";

export const InputFileDropdown = forwardRef<
  HTMLInputElement,
  InputValidatedProps
>(
  (
    {
      label,
      placeholder,
      className,
      mandatory,
      messageClass,
      errorMessage,
      successMessage,
      helperMessage,
      onChange,
      disabled,
      requiredOnly,
      ...rest
    },
    ref,
  ) => {
    const requiredOnlyFormats = transformFileFormats(requiredOnly);

    return (
      <>
        <input
          ref={ref}
          type="file"
          id="files"
          disabled={disabled}
          className={styles.uploadInput}
          accept={requiredOnlyFormats}
          onChange={e => {
            const file = e.target.files?.[0];
            const isValid = validateFile(file);

            if (isValid && onChange) {
              return onChange(e);
            }
          }}
          {...rest}
        />
        {label && (
          <div className={styles.label}>
            {label} {mandatory && <span className={styles.asterix}>*</span>}
          </div>
        )}
        <label
          htmlFor="files"
          className={clsx(
            styles.uploadDocumentsButton,
            className,
            disabled && styles.uploadDocumentsButtonDisabled,
          )}
        >
          <span>{placeholder}</span>
          <Attachments className={styles.icon} />
        </label>
        {messageClass && (
          <span className={clsx(styles.message, messageClass)}>
            {errorMessage || successMessage || helperMessage}
          </span>
        )}
      </>
    );
  },
);
